// Campo de dinheiro estilo caixa registradora (pedido do dono, 29/09/2026:
// "sempre da direita pra esquerda, respeitando os centavos") — o mesmo jeito do
// TrocoModal da Mesa: cada dígito entra pelo centavo e empurra os outros para a
// esquerda (1 → 0,01 · 5 → 0,15 · 0 → 1,50); Backspace tira o último dígito.
// O campo trata as teclas ele mesmo (o lugar do cursor não importa): ao entrar
// nele, o primeiro dígito começa um valor novo — o valor sugerido (ex.: o
// restante no Dividir) é trocado, não emendado. Colar ou teclado de celular
// caem no onChange, que relê só os dígitos.
// `valor` é texto "12.50" (o formato que o Balcão guarda); vazio = zero.
import { useRef } from "react";

const TETO = 999999999; // R$ 9.999.999,99
const fmt = (cents) => (cents / 100).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function CampoCentavos({ valor, onValor, onKeyDown, placeholder = "0,00", className = "", ...resto }) {
  const cents = Math.round((parseFloat(valor) || 0) * 100);
  const novo = useRef(false);
  const gravar = (c) => onValor(c > 0 ? (Math.min(c, TETO) / 100).toFixed(2) : "");
  const tecla = (e) => {
    if (/^\d$/.test(e.key) && !e.ctrlKey && !e.metaKey && !e.altKey) {
      e.preventDefault();
      const base = novo.current ? 0 : cents;
      novo.current = false;
      if (base * 10 + Number(e.key) <= TETO) gravar(base * 10 + Number(e.key));
    } else if (e.key === "Backspace") {
      e.preventDefault();
      novo.current = false;
      gravar(Math.floor(cents / 10));
    } else if (e.key === "Delete") {
      e.preventDefault();
      novo.current = false;
      gravar(0);
    }
    if (onKeyDown) onKeyDown(e);
  };
  const colar = (e) => {
    novo.current = false;
    gravar(parseInt(String(e.target.value).replace(/\D/g, "").slice(0, 9) || "0", 10));
  };
  return (
    <input
      type="text"
      inputMode="numeric"
      value={cents ? fmt(cents) : ""}
      placeholder={placeholder}
      onKeyDown={tecla}
      onChange={colar}
      onFocus={(e) => { novo.current = true; e.target.select(); }}
      className={`text-right tabular-nums outline-none ${className}`}
      {...resto}
    />
  );
}
